import React from "react";
import "./PreLoader.css";
//@ts-ignore
import chip from "../../assets/chip_loader.svg";

const PreLoader = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-[#141414] z-50">
      <img
        alt="Loader"
        src={chip}
        className="absolute self-center animate-spin"
      />
    </div>
  );
};

export default PreLoader;
